import script from "./InputRangePrice.vue?vue&type=script&setup=true&lang=js"
export * from "./InputRangePrice.vue?vue&type=script&setup=true&lang=js"

import "./InputRangePrice.vue?vue&type=style&index=0&id=5ddc82ad&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ddc82ad"]])

export default __exports__